import { createSlice } from "@reduxjs/toolkit";
import {     reKyc_digio_requestResponseThunk } from "./thunk";

export const initialState = {
  reKyc_digio_requestResponseData: [],
  reKyc_digio_requestResponseError: '', // for error message
  reKyc_digio_requestResponseLoading: false,
  
  
};

const Re_Kyc_Digio_Request_Response = createSlice({
  name: "Re_Kyc_Digio_Request_Response",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_digio_requestResponseThunk.pending, (state) => {
      state.reKyc_digio_requestResponseLoading = true ;
      state.reKyc_digio_requestResponseData= [];
      state.reKyc_digio_requestResponseError='';

  });
    builder.addCase(reKyc_digio_requestResponseThunk.fulfilled, (state, action) => {
        state.reKyc_digio_requestResponseData = action.payload.data;
        state.reKyc_digio_requestResponseLoading = false ;
    });
    builder.addCase(reKyc_digio_requestResponseThunk.rejected, (state, action) => {
      state.reKyc_digio_requestResponseError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_digio_requestResponseLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Digio_Request_Response.actions

export default Re_Kyc_Digio_Request_Response.reducer;